import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchCategory } from "../../store/actions/category";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import style from "../../thema/style";
class Navigation extends Component {
  componentDidMount() {
    this.props.fetchCategory();
  }
  state = { menu: false };

  handleCategoryClick = () => {
    this.setState({ menu: false });
    if (this.props.onItemClick) {
      this.props.onItemClick();
    }
  };

  render() {
    // Check if we're in mobile menu context (passed as prop)
    const isMobileMenu = this.props.isMobileMenu;
    
    return (
      <nav>
        <ul>
                  {/* Show toggle only in desktop mobile view, not in mobile menu */}
                  {!(window.innerWidth > 576) && !isMobileMenu && (
                    <li>
                      <Link
                        to={"#"}
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState(({ menu }) => ({ menu: !menu }));
                        }}
                      >
                        <div
                          style={{
                            cursor: "pointer",
                            border: "1px solid #fff",
                            borderRadius: 5,
                            padding: "5px 10px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", this.state.menu ? "times" : "bars"]}
                          />
                        </div>
                      </Link>
                    </li>
                  )}
                  {this.props.category.categories.map((category, i) => {
                    return (
                      <li
                        key={i}
                        style={{
                          display:
                            window.innerWidth > 576
                              ? "inline-block"
                              : isMobileMenu
                              ? "block"
                              : this.state.menu
                              ? "block"
                              : "none",
                        }}
                      >
                        <Link
                          to={{
                            pathname: `/kategori/${category.slug}`,
                            state: { category: category },
                          }}
                          onClick={this.handleCategoryClick}
                          className={
                            (category.style.color || category.style.bg) &&
                            "category-style"
                          }
                          style={{
                            "--category-color": category.style.color,
                            "--category-bg": category.style.bg,
                          }}
                        >
                          {category.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
      </nav>
    );
  }
}

const mapStateToProps = ({ category }) => {
  return { category };
};

const mapDispatchToProps = {
  fetchCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/components/shared/Navigation.js